<sb-card>
  <div card-body>
    <h3>43.430 €</h3>
    <h5>Total amount spent</h5>
  </div>
</sb-card>

<sb-card>
  <div card-body>
    <h3>43.430 €</h3>
    <h5>Total amount spent</h5>
  </div>
</sb-card>

<sb-card>
  <div card-body>
    <h3>43.430 €</h3>
    <h5>Total amount spent</h5>
  </div>
</sb-card>

<sb-card>
  <div card-body>
    <h3>43.430 €</h3>
    <h5>Total amount spent</h5>
  </div>
</sb-card>
